import styled from "styled-components";
import { useState, useContext } from "react";
import { InputText } from "primereact/inputtext";
import { DialogWindowContext } from "../../../../Contexts/DialogueWindowContext";
import { UsersDatabaseContext } from "../../../../Contexts/UserDatabaseContext";
import { searchUserDatabase } from "../../../../Firebase";
import {
  searchUser,
  createNewUserId,
} from "../../../../Helpers/UsersCleanFunctions";
import UserEdit from "../../UserEdit/UserEdit";

import { Button } from "primereact/button";
import { generateRandomString } from "../../../../Helpers/ReportDataFunctions";

const UserEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  margin: 0 auto;
  min-width: 300px;
  align-items: flex-start;
  p {
    font-size: 12px;
    margin-top: 5px;
  }
  .p-inputtext {
    margin: 2px 0 5px 0;
  }
  .p-inputtext,
  .p-treeselect,
  .p-inputwrapper {
    width: 270px;
  }
  .p-inputswitch {
    margin: 5px 0;
  }
`;

export default function AddTeamMemeber({selectedTeam}: Props) {
  const userDatabase = useContext(UsersDatabaseContext);
  const [user, setUser] = useState<UserData>({
    userId: "",
    firstName: "First Name",
    lastName: "Last Name",
    email: [],
    PCRoles: [],
  });
  const DialogWindow = useContext(DialogWindowContext);

  const searchUser = async () => {
    let userToPushToEdit = { ...user };

    const role =
      selectedTeam.teamType === "campus" ? "volunteer" : "oversight";

    userToPushToEdit.PCRoles.push({
      role: role,
      teamId: selectedTeam.teamId,
    });

    userToPushToEdit.userId = generateRandomString();

    const userSearch = await searchUserDatabase(user.email[0]);
    if (userSearch.length > 0 && selectedTeam) {

      userSearch[0].PCRoles.push({
        role: role,
        teamId: selectedTeam.teamId,
        });
      DialogWindow.setDialogProps((prevProps) => ({
        ...prevProps,
        showEditWindow: true,
        header: `${userSearch[0].firstName} ${userSearch[0].lastName}`,
        children: <UserEdit teamMember={userSearch[0]} selectedTeam={selectedTeam} />,
      }));
    }else{
      DialogWindow.setDialogProps((prevProps) => ({
        ...prevProps,
        showEditWindow: true,
        header: "Creating New User",
        children: <UserEdit teamMember={userToPushToEdit} selectedTeam={selectedTeam} />,
      }));
    }
   
  };

  const inputChange = (e: any) => {
    if (e.target.id.includes("firstName")) {
      setUser({ ...user, firstName: e.target.value });
    }
    if (e.target.id.includes("lastName")) {
      setUser({ ...user, lastName: e.target.value });
    }
    if (e.target.id.includes("email")) {
      const newEmail = [e.target.value.toLowerCase()];
      setUser({ ...user, email: newEmail });
    }
  };

  return (
    <UserEditWrapper>
      <p>Okta Email</p>
      <InputText
        id={`email`}
        value={user.email[0] || ""}
        onChange={(e) => inputChange(e)}
        placeholder="Email"
      />
      <Button
        label="Search User"
        style={{ marginTop: "10px", border: "none" }}
        onClick={searchUser}
      />
    </UserEditWrapper>
  );
}

interface Props {
  selectedTeam: OrgTreeItem;
}
